import FormValidationContainer from "../../../../../Components/Forms&Table/Forms/FormControls/FormValidation/FormValidationContainer";

const FormValidation = () => {
  return <FormValidationContainer />;
};

export default FormValidation;
